module.exports = `
... on TableContainer {
  __typename
  title
  styles
}
`;